module.exports = __webpack_public_path__ + "static/img/wheelWhite.f79f230.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/car/wheelWhite.png
// module id = O/R1
// module chunks = 1